import { render, staticRenderFns } from "./CreatePlusAppTemplatePage.vue?vue&type=template&id=60d4bd74&scoped=true&"
import script from "./CreatePlusAppTemplatePage.vue?vue&type=script&lang=js&"
export * from "./CreatePlusAppTemplatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4bd74",
  null
  
)

export default component.exports